














import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'CFilterEmptyPlaceholder'
})
export default class CFilterEmptyPlaceholder extends Vue {}
